<template>
  <div>
    <NBar title="banner图设置" :top="true"/>
    <nut-noticebar :scrollable="false" background="#cee0ff" color="#525975">
      <div class="bar">
        <span>查看banner图支持的设备类型</span>
        <span>></span>
      </div>
    </nut-noticebar>
    <div class="banner-content">
      <span class="title">您还未设置任何banner图</span>
      <nut-button small @click="addBanner()">添加banner图</nut-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  data () {
    return {}
  },
  methods: {
    addBanner () {
      this.$router.push('/device/BannerSet')
    },
  }
}
</script>

<style scoped>
  .bar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .diy-cell {
    margin: 10px 15px;
    border-radius: 5px;
  }

  .diy-cell .text {
    color: #999;
    font-size: 12px;
    margin-left: 5px;
  }

  .banner-content {
    margin: 10px 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #fff;
    height: 300px;
    border-radius: 10px;
  }

  .banner-content .title {
    font-size: 15px;
    margin: 10px 0 20px;
  }

  >>> .nut-button {
    border-radius: 5px;
    background: #409EFF;
    padding: 0 60px;
  }

  >>> .nut-noticebar .content.nut-ellipsis {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/Banner.vue